module.exports = __webpack_public_path__ + "img/google-sign-in-btn.56f00e35.png";